module.exports = __webpack_public_path__ + "static/media/88.2c18d547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/88.jpg
// module id = 1021
// module chunks = 0